import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines and merges Tailwind CSS classes efficiently
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a path for navigation (ensures leading slash)
 */
export function formatPath(path: string): string {
  return path.startsWith('/') ? path : `/${path}`
}

/**
 * Checks if a path is active (current route)
 */
export function isActivePath(currentPath: string, targetPath: string): boolean {
  return currentPath === targetPath
}

/**
 * Generates navigation link classes
 */
export function getNavLinkClasses(isActive: boolean, baseClasses = ''): string {
  return cn(
    'px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200',
    isActive
      ? 'text-primary font-semibold'
      : 'text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary',
    baseClasses
  )
}

/**
 * Generates mobile navigation link classes
 */
export function getMobileNavLinkClasses(isActive: boolean, baseClasses = ''): string {
  return cn(
    'block px-3 py-2 rounded-md text-base font-medium transition-all duration-200',
    isActive
      ? 'text-primary bg-primary/10 font-semibold'
      : 'text-gray-700 dark:text-gray-300 hover:text-primary hover:bg-gray-50 dark:hover:bg-gray-800',
    baseClasses
  )
}

